import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { NewRecordPage } from '~/features/new-record/new-record-page';

/** New record: OS first (stage 10), or `?by=hand` for the record set up by hand on the same draft. */
const search = z.object({ by: z.enum(['hand']).optional() });

export const Route = createFileRoute('/_app/new-record/')({ validateSearch: search, component: NewRecordPage });
